import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import { Breadcrumb, Tabs, Row, Col, Button, Icon, Table, Spin, Drawer, Divider, message } from 'antd';
import KnowMoreDrawer from './KnowMoreDrawer'
import { Link } from 'react-router-dom';
import { SALES_ROLE } from '../../constants/overview';
const TabPane = Tabs.TabPane;

class Events extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            redirectToCreateEvent: false,
            current_page: 1,
            loading: false,
            current_tab: 'ongoing',
            total: 0,
            visible: false,
            showKnowMoreModal: false,
            size: 'large',
            showCsvLoader: false,
            showCsvLoaderId: ''
        };
        this.createEvent = this.createEvent.bind(this)
    }

    componentDidMount () {
        this.fetchRecords()
    }

    onChange = (pageNumber) => {
      this.setState({current_page: pageNumber},function(){
        this.fetchRecords()
      })
    }

    changeTab = (key) => {
      this.setState({current_tab: key, current_page: 1},function(){
        this.fetchRecords();
      })
    }
    
    fetchRecords() {
        let that = this
        this.setState({loading: true})
        window.axios.get(window.API_URL + 'corporate/events/' + this.state.current_tab +  '?page=' + this.state.current_page)
        .then(function (response) {
          console.log(response) 
          that.setState({events: response.data['events'], loading: false, total: response.data['meta']['total']})
        })
        .catch(function (error) {
          that.setState({loading: false})
          console.log(error);
        })
    }

    callback(key) {
        console.log(key);
    }

    createEvent () {
        this.setState({redirectToCreateEvent: true})
    }

    exportToCsv = (record, e) => {  
      let today = new Date()
      let date = record.name + '_' + 'Registration' + '_' + today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      let url = window.API_URL + 'corporate/events/' + String(record.id) + '.csv?download=true'
      this.setState({showCsvLoader: true, showCsvLoaderId: record.id})
      window.axios({
        url: url,
        method: 'GET',
        headers: { 'Accept': 'application/csv',
        'Content-Type': 'application/csv'
        },
        responseType: 'csv',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', date+".csv");
        document.body.appendChild(link);
        link.click();
        this.setState({
          showCsvLoader: false, showCsvLoaderId: ''
        })
        message.success('File downloaded successfully'); 
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          showCsvLoader: false, showCsvLoaderId: ''
        })
      });
    }  

    columns(){
      let columns = []
      
      columns.push({
        title: 'Image',
        dataIndex: 'image',
        key: 'image',
        render: (text, record) => {
          return(
            <img alt="event" src={record.image_url} width="50" height="50"/>
          )
        }
      })
      columns.push({
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      })
      columns.push({
        title: 'Start Time',
        dataIndex: 'start_time',
        key: 'start_time'
      })
      columns.push({
        title: 'Action',
        dataIndex: 'action',
        render: (text, record) => {
          return(
            
             this.state.current_tab === "completed" ? 
              <span>
              <a style={{marginLeft: 0,color: '#2168f3'}} onClick={() =>this.showEvent(record.id)}>Know More</a> 
              
              </span> : <span> <a href={"/wellness-calendar/event/" + String(record.id) + "/edit"}><Icon type="edit" style={{color: '#2168f3'}} /></a>
              <Divider type="vertical" />
              <a style={{marginLeft: 0,color: '#2168f3'}} onClick={() =>this.showEvent(record.id)}>Know More</a> 
            </span> 
          )  
        }
      })
      columns.push({
        title: 'Registrations',
        dataIndex: 'registrations',
        render: (text, record) => {
          if(this.state.showCsvLoader === true && this.state.showCsvLoaderId === record.id){
            return(
              <span>
               <a style={{marginLeft: 25}}><Icon type="loading" style={{color: '#2168f3'}}/></a>
              </span>
            )
           }else{
           return(
            <span>
              <a type="primary" style={{marginLeft: 25, pointerEvents: `${SALES_ROLE === 'sales' ? 'none' : ''}`}} onClick={this.exportToCsv.bind(this, record)}><Icon type="download" style={{color: '#2168f3'}} /></a>
            </span>
           )
          }
        }
      })

      return columns

    }

    updateEvent = () => {
      this.setState({
        visible: false,
        showKnowMoreModal: false
      });
      this.fetchRecords()
    }

    showEvent = (id) => {
      this.setState({ visible: true, event_id: id,showKnowMoreModal: true })
    }

    handleCancel = (e) => {
      this.setState({
        visible: false,
        showKnowMoreModal: false
        });
      this.fetchRecords()
    }

    handleClose = (e) => {
      this.setState({
        visible: false,
        showKnowMoreModal: false
      });
      this.fetchRecords()  
    }

    cancelModal(e){
      this.setState({showKnowMoreModal: false})
    }

    renderModal(){
      if (this.state.showKnowMoreModal) {
        return(<Drawer
          width={'30%'}
          visible={this.state.visible}
          onCancel={this.handleCancel}
          onClose={this.handleClose}
          footer={null}
          >
          <KnowMoreDrawer visible={this.state.showKnowMoreModal} 
                          eventId={this.state.event_id}
                          postUpdate={this.updateEvent}
                          closeModal={this.cancelModal.bind(this)}/>
          </Drawer>
        )  
      } else {
        return(<div/>)
      }  
    }  

    render () {
        let { redirectToCreateEvent } = this.state;
        if (redirectToCreateEvent) {
            return <Redirect to='events/createEvent'/>;
        }
        let text_value_ongoing = "Ongoing"
        let text_value_completed = "Completed"
        let text_value_draft = "Draft"
        if (this.state.current_tab === "ongoing"){
          if(this.state.total >= 0){
            text_value_ongoing = "Ongoing " + "(" + this.state.total + ")"
          }
        }else if(this.state.current_tab === "completed"){
          if(this.state.total >= 0){
            text_value_completed = "Completed " + "(" + this.state.total + ")"
          }
        }else if(this.state.current_tab === "deactivated"){
          if(this.state.total >= 0){
            text_value_draft = "Draft " + "(" + this.state.total + ")"
          }
        }
        return (

          <div style={{marginTop: 10 }}>
            <div style={{marginTop: 10 }}>
              <Row type="flex" justify="end" style={{marginBottom: 10}}>
                <Button type="primary"><Link type="primary" className="pull-right" to="/wellness-calendar"><Icon type="calendar" /> View Calendar</Link></Button> 
              </Row>    
              <Row gutter={16} style={{margin: 0, background:"#ffffff"}}>   
                <Spin spinning={this.state.loading}>
                <Tabs defaultActiveKey={this.state.current_tab} onTabClick={this.changeTab}>  
                  <TabPane tab={text_value_ongoing} key="ongoing">
                    <Table  rowKey="id" dataSource={this.state.events} pagination={{pageSize: 15, total: this.state.total, onChange: this.onChange}} columns={this.columns()} />
                  </TabPane>
                  <TabPane tab={text_value_completed} key="completed">
                    <Table  rowKey="id" dataSource={this.state.events} pagination={{pageSize: 15, total: this.state.total, onChange: this.onChange}} columns={this.columns()} />
                  </TabPane>
                  <TabPane tab={text_value_draft} key="deactivated">
                    <Table  rowKey="id" dataSource={this.state.events} pagination={{pageSize: 15, total: this.state.total, onChange: this.onChange}} columns={this.columns()} />
                  </TabPane>
                </Tabs>
                </Spin>
              </Row>  
            </div>
            {this.renderModal()} 
          </div>  
        )
    }
}
export default Events;